import { ReactNode } from 'react'
import { useTheme } from '@mui/material'
import { DatePicker } from '@mui/x-date-pickers'
import moment, { Moment } from 'moment'

import { useStyles } from './styles'
import { HelperWrapper } from '../helper-wrapper'

interface IDateInputProps {
  value: Moment | null
  handleChange: (date: Moment | null) => void
  error?: string
  label?: string | ReactNode
  disabled?: boolean
}

const DateInput = ({ value, handleChange, error, label, disabled }: IDateInputProps) => {
  const classes = useStyles({ disabled })
  const theme = useTheme()

  return (
    <DatePicker
      disabled={disabled}
      label={label}
      value={value ? value : disabled ? moment('DD/MM/YYYY') : null}
      onChange={handleChange}
      format="DD/MM/YYYY"
      className={classes.input}
      slotProps={{
        textField: {
          focused: true,
          helperText: error && <HelperWrapper t={error} />,
          InputLabelProps: {
            className: classes.labelText,
            style: {
              color: theme.palette.custom.grey2,
            },
          },
          FormHelperTextProps: {
            className: classes.errorText,
          },
        },
      }}
    />
  )
}

export { DateInput }
